import { render, staticRenderFns } from "./ObjectsSelector.vue?vue&type=template&id=99b6b52a"
import script from "./ObjectsSelector.vue?vue&type=script&lang=js"
export * from "./ObjectsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports